import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ButtonHTMLAttributes } from 'react';
import type { ButtonProps } from '../../components/button/types';
import { GLOBAL_ICONS } from '../../util/vars';
import { Button } from '../../components';

type Ref = HTMLButtonElement;
type HTMLProps = Omit<ButtonHTMLAttributes<Ref>, 'color'>;
interface Props extends ButtonProps, HTMLProps {
  children?: string | null,
}

const CancelButtonModal = ({
  children,
  ...other
}: Props): JSX.Element => {

  const { translate } = useI18n();

  return (
    <Button isOutline asLink icon={GLOBAL_ICONS.close} data-cy="cancel-button-modal" color={'black'} {...other}>
      {children ?? translate('components.BUTTONS.CANCEL')}
    </Button>
  );
};

CancelButtonModal.displayName = 'CancelButtonModal';

export default CancelButtonModal;
